<template>
	<div>
		<case-form :schema="schema" class="mt6" />
	</div>
</template>

<script>
import CaseForm from "@/modules/caseManagement/components/CaseForm/CaseForm.vue"
export default {
	components: {
		CaseForm
	},

	computed: {
		schema() {
			return [
				{
					label: "Holder",
					component: "entitySelect",
					bindTo: "case.holder",
					entity: "case.holder",
					props: {
						allowedEntityTypes: ["individual"]
					}
				},
				{
					label: "Title",
					component: "entityField",
					entity: "case.holder",
					fieldToUpdate: "salutation",
					props: {
						updateOptions: {
							component: "select",
							props: {
								options: [
									{
										name: "Mr",
										value: "Mr"
									},
									{
										name: "Mrs",
										value: "Mrs"
									},
									{
										name: "Miss",
										value: "Miss"
									},
									{
										name: "Other",
										value: "Other"
									}
								]
							}
						}
					}
				},
				{
					label: "Other Titles",
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderotherTitles`,
					props: {
						suggest: {
							typeIncludes: `otherTitles`
						},
						createOptions: {
							type: `otherTitles`,
							dataType: "string"
						}
					}
				},
				{
					label: "Suffix",
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holdersuffix`,
					props: {
						suggest: {
							typeIncludes: `suffix`
						},
						createOptions: {
							type: `suffix`,
							dataType: "string"
						}
					}
				},
				{
					label:
						"Are you/have you been known under any Former Name, Maiden Name or Alias?",
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderhasFormerNameOrAlias`,
					props: {
						suggest: {
							typeIncludes: `hasFormerNameOrAlias`
						},
						createOptions: {
							type: `hasFormerNameOrAlias`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "If “Yes,” please provide the other names below",
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderformerNameOrAlias`,
					props: {
						suggest: {
							typeIncludes: `formerNameOrAlias`
						},
						createOptions: {
							type: `formerNameOrAlias`,
							dataType: "string"
						}
					}
				},
				{
					label: "Date Of Birth",
					component: "entityField",
					entity: "case.holder",
					fieldToUpdate: "dateOfBirth",
					props: {
						updateOptions: {
							component: "date"
						}
					}
				},
				{
					label: "City Of Birth",
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holdercityOfBirth`,
					props: {
						suggest: {
							typeIncludes: `cityOfBirth`
						},
						createOptions: {
							type: `cityOfBirth`,
							dataType: "string"
						}
					}
				},
				{
					label: "Country Of Birth",
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holdercountryOfBirth`,
					props: {
						suggest: {
							typeIncludes: `countryOfBirth`
						},
						createOptions: {
							type: `countryOfBirth`,
							dataType: "string"
						}
					}
				},
				{
					label: "Countries of Citizenship",
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holdercountriesOfCitizenship`,
					props: {
						suggest: {
							typeIncludes: `countriesOfCitizenship`
						},
						createOptions: {
							type: `countriesOfCitizenship`,
							dataType: "string"
						}
					}
				},
				{
					label: "Current Address",
					component: "entityAddress",
					entity: "case.holder",
					relation: "case.holder.addresses",
					bindTo: "case.facts.holderpermanentReisdentAddress",
					props: {
						suggest: {
							typeIncludes: "permanentReisdentAddress"
						},
						createOptions: {
							type: "permanentReisdentAddress"
						}
					}
				},
				{
					label: "Mailing Address (if different from above)",
					component: "entityAddress",
					entity: "case.holder",
					relation: "case.holder.addresses",
					bindTo: "case.facts.holdermailingAddress",
					props: {
						suggest: {
							typeIncludes: "mailingAddress"
						},
						createOptions: {
							type: "mailingAddress"
						}
					}
				}
			]
		}
	}
}
</script>
